import { atomWithKey as atom } from "./atomWithKey";
import { ICmsNetworkDetail, ICmsNetworkMapStationInfoResponse, ICmsNetworkMapStations } from "../Types/Index";


export const networkMapStationResponseAtom = atom<ICmsNetworkMapStations[]>({
  key: "networkMapStationResponseAtom",
  default: [],
});

export const networkDetailResponseAtom = atom<ICmsNetworkDetail>({
  key: "networkDetailResponseAtom",
  default: {} as ICmsNetworkDetail,
});

export const networkMapStationInfoResponseAtom = atom<ICmsNetworkMapStationInfoResponse | null>({
  key: "networkMapStationInfoResponseAtom",
  default: null,
});
